/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerLockScreenActionDto } from '../models/EntityModelResponseContainerLockScreenActionDto';
import type { LockScreenActionDto } from '../models/LockScreenActionDto';
import type { PagedModelEntityModelLockScreenActionDto } from '../models/PagedModelEntityModelLockScreenActionDto';
import type { PagedResourcesAssemblerLockScreenActionDto } from '../models/PagedResourcesAssemblerLockScreenActionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LockScreenActionControllerService {
    /**
     * @returns PagedModelEntityModelLockScreenActionDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerLockScreenActionDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelLockScreenActionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/configuration/lock-screen-actions',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerLockScreenActionDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: LockScreenActionDto,
    }): CancelablePromise<EntityModelResponseContainerLockScreenActionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/configuration/lock-screen-actions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        actionId,
    }: {
        actionId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/configuration/lock-screen-actions/{actionId}',
            path: {
                'actionId': actionId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerLockScreenActionDto OK
     * @throws ApiError
     */
    public static read({
        actionId,
    }: {
        actionId: number,
    }): CancelablePromise<EntityModelResponseContainerLockScreenActionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/configuration/lock-screen-actions/{actionId}',
            path: {
                'actionId': actionId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerLockScreenActionDto OK
     * @throws ApiError
     */
    public static update({
        actionId,
        requestBody,
        xIgnoreNulls,
    }: {
        actionId: number,
        requestBody: LockScreenActionDto,
        xIgnoreNulls?: string,
    }): CancelablePromise<EntityModelResponseContainerLockScreenActionDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/configuration/lock-screen-actions/{actionId}',
            path: {
                'actionId': actionId,
            },
            headers: {
                'X-IGNORE-NULLS': xIgnoreNulls,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
